import { Outlet } from "react-router-dom";
import Header from "../../components/common/Header";

const AuthLayout = () => {
  return (
    <>
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default AuthLayout;
